import { createAction } from 'typesafe-actions'

import { Id, ResumeHotel, FullRequestHotelsHistory } from 'src/types'

import { HotelFilters, HotelsActionTypes, HotelSearchType } from './types'

export const getHotels = createAction(
  HotelsActionTypes.GET_HOTELS,
  action =>
    ({
      customer_supplier_id,
      filters,
      reason_id,
      searchKey,
      searchType
    }: {
      filters: HotelFilters
      customer_supplier_id?: Id
      reason_id: Id
      searchKey: string
      searchType: HotelSearchType
    }) =>
      action({
        customer_supplier_id,
        filters,
        reason_id,
        searchKey,
        searchType
      })
)

export const getHotelsFailure = createAction(
  HotelsActionTypes.GET_HOTELS_FAILURE,
  action => (searchKey: string, message: string) =>
    action({ message, searchKey })
)

export const getHotelsHistory = createAction(
  HotelsActionTypes.GET_HOTELS_HISTORY,
  action =>
    ({ request_id }: { request_id: Id }) =>
      action({ request_id })
)

export const getHotelsHistoryFailure = createAction(
  HotelsActionTypes.GET_HOTELS_HISTORY_FAILURE,
  action => (message: string) => action({ message })
)

export const getHotelsHistorySuccess = createAction(
  HotelsActionTypes.GET_HOTELS_HISTORY_SUCCESS,
  action =>
    ({ historyList }: { historyList: FullRequestHotelsHistory }) =>
      action({ historyList })
)

export const getHotelsSuccess = createAction(
  HotelsActionTypes.GET_HOTELS_SUCCESS,
  action => (searchKey: string, search: ResumeHotel[], message_id: string[]) =>
    action({ searchKey, search, message_id })
)

export const resetHotels = createAction(
  HotelsActionTypes.RESET_HOTELS,
  action => () => action()
)

export const setHotelsNextPeriodKey = createAction(
  HotelsActionTypes.SET_HOTELS_NEXT_PERIOD_KEY,
  action => () => action()
)

export const setHotelsPeriodKey = createAction(
  HotelsActionTypes.SET_HOTELS_PERIOD_KEY,
  action => (periodKey: string) => action({ periodKey })
)

export const setHotelsFilterName = createAction(
  HotelsActionTypes.SET_HOTELS_FILTERS_NAME,
  action =>
    ({ value }: { value: string }) =>
      action({ value })
)

export const setHotelsFilterQuarter = createAction(
  HotelsActionTypes.SET_HOTELS_FILTERS_QUARTER,
  action =>
    ({ index }: { index: number }) =>
      action({ index })
)

export const setHotelsFilterQuarterAll = createAction(
  HotelsActionTypes.SET_HOTELS_FILTERS_QUARTER_ALL,
  action =>
    ({ checked }: { checked: boolean }) =>
      action({ checked })
)
